import { render, staticRenderFns } from "./CrearDocumentos.vue?vue&type=template&id=2b2d2580&scoped=true"
import script from "./CrearDocumentos.vue?vue&type=script&lang=js"
export * from "./CrearDocumentos.vue?vue&type=script&lang=js"
import style0 from "./CrearDocumentos.vue?vue&type=style&index=0&id=2b2d2580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2d2580",
  null
  
)

export default component.exports